function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "stay_svg__a",
  x: 29.653,
  y: 21.714,
  width: 25.922,
  height: 26.364,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c",
  floodOpacity: 0.667
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "stay_svg__c",
  x: 0,
  y: 10.404,
  width: 28.973,
  height: 34.371,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "d"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c"
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "d"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".stay_svg__d{fill:#1b1c26}.stay_svg__g{fill:#ff6c6c}.stay_svg__k{fill:none}.stay_svg__j{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.393 4.676)",
  stroke: "#1b1c26",
  strokeWidth: 2,
  fill: "#383d5a"
}, /*#__PURE__*/React.createElement("rect", {
  className: "stay_svg__j",
  width: 31.169,
  height: 52.987,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  className: "stay_svg__k",
  x: 1,
  y: 1,
  width: 29.169,
  height: 50.987,
  rx: 4
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "stay_svg__d",
  d: "M27.837 27.546A13.355 13.355 0 0114.483 40.9c-.349 0-.688-.01-1.027-.041a13.348 13.348 0 010-26.617 8.495 8.495 0 011.027-.051 13.355 13.355 0 0113.354 13.355z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "stay_svg__d",
  d: "M25.056 27.545a10.573 10.573 0 01-10.574 10.574c-.277 0-.545-.008-.813-.033a10.568 10.568 0 010-21.074 6.726 6.726 0 01.813-.04 10.573 10.573 0 0110.574 10.573zm6.661 23.279a1.182 1.182 0 110 2.364h-5.48a1.182 1.182 0 110-2.364z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41.848 37.982l-11.967-5.127a1.826 1.826 0 01.105-.605 1.8 1.8 0 01-.105-.6l11.967-5.129a1.778 1.778 0 011.434 0l1.1.473 10.867 4.656a1.9 1.9 0 01-.1.6 1.929 1.929 0 01.1.605l-10.867 4.658-1.1.469a1.753 1.753 0 01-.715.15 1.778 1.778 0 01-.719-.15z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "#1b1c26",
  stroke: "#1b1c26",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.652 25.715)",
  fill: "#ff6c6c",
  stroke: "#1b1c26",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  className: "stay_svg__j",
  width: 17.922,
  height: 16.364,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "stay_svg__k",
  x: 1,
  y: 1,
  width: 15.922,
  height: 14.364,
  rx: 3
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.001 .005)",
  filter: "url(#stay_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "stay_svg__g",
  width: 13.922,
  height: 14.364,
  rx: 2,
  transform: "translate(35.65 27.71)"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M55.248 32.075v12.683a1.817 1.817 0 01-1.812 1.812H31.695a1.817 1.817 0 01-1.812-1.812V32.075l11.967 5.127a1.788 1.788 0 001.431 0l1.1-.471z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#1b1c26",
  strokeWidth: 2,
  fill: "#383d5a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "stay_svg__d",
  d: "M44.99 31.47a1 1 0 010 1.736L42.551 34.6a1 1 0 01-1.5-.868v-2.788a1 1 0 011.5-.868z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.004 -.004)",
  filter: "url(#stay_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  className: "stay_svg__g",
  d: "M13.305 35.35a1.829 1.829 0 01-.41-2.314h-1.973a1.9 1.9 0 01-1.9-1.518 1.813 1.813 0 01.969-1.939 1.649 1.649 0 00.83-1.48v-2.381a3.656 3.656 0 012.072-3.295 1.966 1.966 0 113.631-1.047 1.929 1.929 0 01-.34 1.105 3.655 3.655 0 011.953 3.236v2.461a1.686 1.686 0 00.916 1.445 1.817 1.817 0 01.887 1.895c-.15.893-.99 1.518-2.441 1.518h-1.436a1.828 1.828 0 01-2.76 2.314z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M24.534 10.383h-.231m9.504 0h-6.989",
  fill: "none",
  strokeLinecap: "round",
  stroke: "#1b1c26",
  strokeWidth: 2
});

var SvgStay = function SvgStay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60.146,
    height: 60
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

export default "data:image/svg+xml;base64,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";
export { SvgStay as ReactComponent };